// Load admin routes dynamically.
const requireModulesFiles = require.context("./modules/", false, /.*\.js$/);
export default requireModulesFiles
  .keys()
  .map((file) => [
    file.replace(/(^.\/)|(\.js$)/g, ""),
    requireModulesFiles(file),
  ])
  .reduce((modules, [name, module]) => {
    modules[name] = module.default[0];
    return modules;
  }, []);
